module.exports = __webpack_public_path__ + "static/form-2-13e023acb34cc0831db367518bdbe6ef.jpg";